/* eslint-disable react/jsx-no-undef */
import { React, useEffect, useState } from "react";
import { useNavigate, useLocation, Link } from "react-router-dom";
import { useAuth } from "../../../navigation/Auth/auth";
import { Button, Grid, TextField } from "@material-ui/core";
import axios from "axios";
import Cookies from "js-cookie";
import * as sweetalert from "sweetalert";
import packageJson from "../../../../package.json";
import Controls from "../global/controls/Controls";
import { useForm } from "./useForm";
export const BaseUrl = packageJson.projectURlApi.BaseUrl;
export const PrivcePoliceAccept = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [loading, setLoading] = useState(false);
  const [Privcepolice, setPrivcepolice] = useState("");
	const [content, setContent] = useState('');
	const [notes, setNotes] = useState('');
  const auth = useAuth();
  const redirectPath = 
  location.state?.path ||  "/dashboard";
  const initialFValues = {
    mobile_number: "",
    password: "",
    auth:"",
  };
  const validate = (fieldValues = loginInput) => {
    let temp = { ...errors };
    temp.mobile_number = fieldValues.mobile_number ? "" : "رقم الهاتف مطلوب";
  
    if (fieldValues.mobile_number) {
      if (!/^[0-9]+$/.test(fieldValues.mobile_number)) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل أرقام فقط";
      } else if (fieldValues.mobile_number.length !== 10) {
        temp.mobile_number = "يجب أن يكون رقم الموبايل 10 أرقام";
      }
    }
  
    temp.password = fieldValues.password ? "" : "كلمة السر مطلوبة";
  
    if (fieldValues.password) {
      if (fieldValues.password.length < 8) {
        temp.password = "يجب أن تكون كلمة السر على الأقل 8 أحرف";
      }
    }
  
    setErrors({
      ...temp,
    });
  
    if (fieldValues === loginInput) {
      return Object.values(temp).every((x) => x === "");
    }
  };
  useEffect(() => {
    axios
      .get(
        `${BaseUrl}/api/privacyPolicy`
      )
      .then((res) => {
        setContent(res.data.data.content);
        setNotes(res.data.data.notes);
   
      })
      .catch((err) => {});
  }, []);
  const handeleInput = (e) => {
    e.persist();
    setLogin({
      ...loginInput,
      [e.target.name]: e.target.value,
    });
  };

  const loginSubmit = (e) => {

    e.preventDefault();

      setLoading(true);
      const config = {
        headers: {
          Accept: "application/json",
          Authorization: null,
          sameSite: "strict",
        },
      };
      const data = {
        mobile_number: loginInput.mobile_number,
        password: loginInput.password,
        // auth: Cookies.get("jwt"),
      };

      axios.post(`${BaseUrl}/api/agreePrivacyPolicy`, {
        withCredentials: true,
      }).then((response) => {
        if(response.data.status === true){
          sweetalert(response.data.msg, {
            className: "alert-div",
            button: {
              text: "تم",
            },
          }).then(() => {
            axios
            .post(`${BaseUrl}/api/mobile/login`, data, {
              withCredentials: true,
            })
            .then((res) => {
  
              if (res.data.status === true) {
        
                setLoading(false);
                localStorage.setItem("is loggedIn", true);
                localStorage.setItem("staff_type", res.data.data.staff_type);
                const locale = localStorage.getItem("is loggedIn");
                const user = locale;
                auth.login(user);
  
           
                navigate(redirectPath, { replace: true });
              } else {
                setLoading(false);
                sweetalert("error");
                setLogin({ ...loginInput, error_list: res.data.error });
              }
            });
          });
        }
       
      }).catch((err) => {
        if (err.response && err.response.status === 500) {
          sweetalert(err.response.msg, {
            className: "alert-div",
            button: {
              text: "تم",
            },
          });
        }
      });
    
  
  };
  const { loginInput, setLogin, errors, setErrors } = useForm(
    initialFValues,
    true,
    validate
  );
  const logoutSubmit = () => {
    
    localStorage.removeItem("is loggedIn");
    localStorage.removeItem("staff_type");
 
    
    navigate("/");
    window.location.reload();
  };
  return (
    <div>
      <form className="form-group" >
        <Grid container style={{ minHeight: "auto" }}>
          <Grid
            container
            item
            alignItems="flex-start"
            direction="column"
            justify="flex-start"
            xs={12}
            sm={6}
            style={{ padding: 10 }}
          >
                   <div>
              
              <h3 className="title-home"> سياسة الخصوصية</h3>
            </div>
          
            <div
              style={{
                display: "flex",
                flexDirection: "column",
              }}
            >
                       <div dangerouslySetInnerHTML={{ __html: content }} />
              <h3 className="title-home"> ملاحظات</h3>
                       <div dangerouslySetInnerHTML={{ __html: notes }} />

         
          {/* {Privcepolice.content} */}
                {/* <div style={{display:'flex' , justifyContent:'center'}}>
                  <Controls.Button
                    type="submit"
                    onClick={loginSubmit}
                    text="قبول"
                    variant="contained"
                    className="btn-submit"
                  ></Controls.Button>
               
             
                  <Controls.Button
                    type="submit"
                    onClick={logoutSubmit}
                    text="رفض"
                    variant="contained"
                    className="btn-submit-no"
                  ></Controls.Button>
                </div> */}
             

          
            </div>
          </Grid>
        </Grid>
      </form>
    </div>
  );
};
